module.exports = __webpack_public_path__ + "static/media/highlight_off_icon.6d30f758.svg";